// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* "Jump to latest" pill (memo dev/75): dark-pill accent matching the chat
   chrome (user bubbles / top bar use the same token). Absolute overlay — the
   parent wraps the scroll container in a position:relative box, so appearing
   never shifts layout. */
.HFqyXdfv1OSqSC8H32Dj {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: none;
  border-radius: 999px;
  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));
  color: var(--curio-text-on-dark, var(--curio-text-on-dark));
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  animation: fG9Di0LsCCEFVUIkUDUQ 120ms ease-out;
}

.HFqyXdfv1OSqSC8H32Dj:hover {
  filter: brightness(1.25);
}

.HFqyXdfv1OSqSC8H32Dj:focus-visible {
  outline: 2px solid var(--curio-top-bar-bg, var(--curio-focus-ring));
  outline-offset: 2px;
}

@keyframes fG9Di0LsCCEFVUIkUDUQ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .HFqyXdfv1OSqSC8H32Dj {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/TranscriptJumpButton.module.css"],"names":[],"mappings":"AAAA;;;yBAGyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,4DAA4D;EAC5D,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,8CAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* \"Jump to latest\" pill (memo dev/75): dark-pill accent matching the chat\n   chrome (user bubbles / top bar use the same token). Absolute overlay — the\n   parent wraps the scroll container in a position:relative box, so appearing\n   never shifts layout. */\n.jump {\n  position: absolute;\n  bottom: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 5;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border: none;\n  border-radius: 999px;\n  background: var(--curio-top-bar-bg, var(--curio-top-bar-bg));\n  color: var(--curio-text-on-dark, var(--curio-text-on-dark));\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  animation: jumpFadeIn 120ms ease-out;\n}\n\n.jump:hover {\n  filter: brightness(1.25);\n}\n\n.jump:focus-visible {\n  outline: 2px solid var(--curio-top-bar-bg, var(--curio-focus-ring));\n  outline-offset: 2px;\n}\n\n@keyframes jumpFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .jump {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jump": `HFqyXdfv1OSqSC8H32Dj`,
	"jumpFadeIn": `fG9Di0LsCCEFVUIkUDUQ`
};
export default ___CSS_LOADER_EXPORT___;
